
import HeaderView from "@/components/Header.vue"; // @ is an alias to /src
import Footer from "@/components/Footer.vue"; // @ is an alias to /src
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isRouterAlive: true,
      highlight: false,
    };
  },
  components: {
    HeaderView,
    Footer,
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    ...mapGetters("device", {
      isFullHeader: "getIsFullHeader",
    }),
  },
  mounted() {
    window.vue.reloadApp = this.reload.bind(this);
  },
  watch: {
    $route(to, from) {
      if (!from || !from.name || to.path === from.path) return;
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  methods: {
    reload: function () {},
  },
};
